/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const PATH = 'nerve/ldap';

class LdapApiService extends BaseApiService {
  getActiveLdap() {
    return this.get(`${PATH}/active`, { authRequired: true });
  }

  getAll() {
    return this.get(PATH, { authRequired: true });
  }

  getOne(name) {
    return this.get(`${PATH}/${name}`, { authRequired: true });
  }

  create(data) {
    return this.post(PATH, data, { authRequired: true });
  }

  update(data) {
    return this.put(`${PATH}/${data.fileName}`, data, { authRequired: true });
  }

  deleteOne(name) {
    return this.delete(`${PATH}/${name}`, { authRequired: true });
  }

  testConnection(ldap) {
    return this.post(`${PATH}/connection/test`, ldap, { authRequired: true });
  }

  setActiveLdap(data) {
    return this.patch(`${PATH}/${data.name}/active`, { active: data.active }, { authRequired: true });
  }

  getDefaultLdap() {
    return this.get(`${PATH}/default`, { authRequired: true });
  }

  getAllRoles(params) {
    return this.get('nerve/rbac/roles', { params }, { authRequired: true });
  }

  testGroupsSync(params) {
    return this.post(`${PATH}/query/groups`, params, { authRequired: true });
  }

  testUsersSync(params) {
    return this.post(`${PATH}/query/users`, params, { authRequired: true });
  }

  sync(ldap) {
    return this.post(`${PATH}/sync`, ldap, { authRequired: true });
  }
}

export default new LdapApiService();
